/**
 * Utility function to be used when checking for exhaustiveness of switch statements using a type field.
 * See https://www.typescriptlang.org/docs/handbook/advanced-types.html#exhaustiveness-checking for mor info on this.
 */
export function assertNever(x: never): never {
  throw new Error('Unexpected object: ' + x);
}
